import { useCallback, useState } from 'react';

export const useBooleanState = (value) => {
  const [on, setOn] = useState(value);
  const toggleOn = useCallback(() => setOn(!on), [on]);
  return [on, toggleOn, setOn];
};
